import { useTracking } from '@xing-com/crate-communication-tracking';

export function useTrackPageView(): () => void {
  const { track } = useTracking();

  return () => {
    track({
      type: 'nwt',
      eventSchema: 'basic',
      sentBy: 'welcome',
      page: 'welcome/start/index',
      event: 'viewed_screen',
      channel: 'wbm/Welcome',
    });
  };
}

export function useTrackClickStoreButton(): (action: string) => void {
  const { track } = useTracking();

  return (action: string) => {
    const mobileOs = action.includes('android') ? 'android' : 'ios';

    track({
      event: 'visited',
      eventSchema: 'basic',
      sentBy: 'welcome',
      element: `download_${mobileOs}_app`,
      page: 'welcome/start/index',
      type: 'nwt',
      channel: 'wbm/Welcome',
    });
  };
}

export function useTrackSignUpGoogle(): () => void {
  const { track } = useTracking();

  return () => {
    track({
      event: 'visited',
      eventSchema: 'basic',
      sentBy: 'welcome',
      element: 'continue_with_google',
      page: 'welcome/start/index',
      type: 'nwt',
      channel: 'wbm/Welcome',
    });
  };
}

export function useTrackSignUp(): () => void {
  const { track } = useTracking();

  return () =>
    track({
      type: 'nwt',
      event: 'opened',
      eventSchema: 'basic',
      sentBy: 'welcome',
      element: 'register',
      elementDetail: 'create_profile_button',
      page: 'welcome/start/index',
      channel: 'wbm/Welcome',
    });
}

export function useTrackSaveClick(): () => void {
  const { track } = useTracking();

  return () => {
    track({
      type: 'nwt',
      event: 'opened',
      eventSchema: 'basic',
      sentBy: 'welcome',
      element: 'save_job_preferences',
      page: 'welcome/start/index',
      channel: 'wbm/Welcome',
    });
  };
}
